import { ControlProps, RankedTester, rankWith } from "@jsonforms/core";
import React from "react";
import { Box } from "@mui/material";

export const UnknownRenderer = ({ schema, uischema }: ControlProps) => {
  /* Do not remove below console log this is added for debugging purpose */
  console.log("UnknownRenderer schema ==>", schema);
  console.log("UnknownRenderer uischema ==>", uischema);
  return (
    <Box style={{ color: "red" }}>
      Unknown Renderer (Check logs to find more details)
    </Box>
  );
};

export const unknownRendererTester: RankedTester = rankWith(1, () => true);
